import { Link as RouterLink } from "react-router";
import { Link, type LinkProps } from "@/components/ui/link.tsx";

const DEFAULT_LINK_HOVER = "hover:text-fg hover:underline underline-offset-4";

export function RoutedLink({ className, ...props }: LinkProps) {
    const composedClassName = "href" in props && typeof className !== "function" ? `${DEFAULT_LINK_HOVER} ${className ?? ""}`.trim() : className;

    return (
        <Link
            {...props}
            className={composedClassName}
            render={domProps => {
                if ("href" in domProps) {
                    const { href, ...rest } = domProps;

                    return <RouterLink to={href} {...rest} />;
                }

                return <span {...domProps} />;
            }}
        />
    );
}
